import { Skeleton, Button, Space, message } from "antd";
import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import html2pdf from "html2pdf.js";
import "../../App.css";
axios.interceptors.request.use((config) => {
  config.headers["Access-Control-Allow-Origin"] = "*";
  config.headers["Access-Control-Allow-Headers"] = "*";
  config.headers["Access-Control-Allow-Methods"] = "*";
  return config;
});
const CONN_KEY = process.env.REACT_APP_NOT_SECRET_CODE_R;
function MenuGeu() {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const invoiceSectionRef = useRef(null);
  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fakturaUrl = `${CONN_KEY}menuGeudata.php`;
        const fakturaResponse = await axios.get(fakturaUrl);
        setData(fakturaResponse.data);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const handleDownload = async () => {
    if (!invoiceSectionRef.current) return;

    const originalContents = document.body.innerHTML;
    const images = invoiceSectionRef.current.getElementsByTagName("img");

    try {
      // Convert all images to base64
      const loadImagePromises = Array.from(images).map(async (image) => {
        const imageUrl = image.src; // Use the direct image URL
        const response = await axios.get(imageUrl, { responseType: "blob" });
        const blob = response.data;

        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            image.src = reader.result; // Replace image src with base64
            resolve();
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      });

      await Promise.all(loadImagePromises);

      // PDF generation options
      const opt = {
        margin: 0,
        filename: `menu.pdf`,
        image: { type: "jpeg", quality: 0.5 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };

      // Generate and save the PDF
      await html2pdf().set(opt).from(invoiceSectionRef.current).save();
    } catch (error) {
      console.error("Error during PDF generation:", error);
      message.error("Error generating PDF. Please try again.");
    } finally {
      // Restore the original contents of the page
      document.body.innerHTML = originalContents;
    }
  };

  console.log("isLoading:", isLoading);
  const items = Object.keys(data)
    .filter((key) => data[key].Catagory === "CATEGORY_NAME") // Replace CATEGORY_NAME with the actual category name
    .map((key) => data[key])
    .sort((a, b) => a.product.localeCompare(b.product)); // Sort items by product name

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <>
          <Space>
            {/* <Button onClick={handlePrint}>Print</Button> */}
            <Button onClick={handleDownload}>Updata PDF</Button>
          </Space>
          <div className="container">
            <div id="invoice-section" ref={invoiceSectionRef}>
              <div className="jjhgdf-menu-geo-1 page-menu-geo-1">
                <div className="djhvms7">
                  <div style={{ marginTop: 137, display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column", backgroundColor: "#1A191E", padding: 10 }}>
                    {/* Inside the "WHISKEY" category section: */}
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "Mezeler")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsgeo" key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-geo-2 page-menu-geo-2">
                <div className="ssfsdbVOD">
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "Çorbalar")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsgeo" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
                <div style={{ marginTop: 7, display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                  {/* Inside the "WHISKEY" category section: */}
                  <h1
                      className="dhjsfbs2"
                      style={{ top: "1322px", left: "285px" }}
                    >
                      Salatlar
                    </h1>
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "Salatlar")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsgeo" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
              </div>
              <div className="jjhgdf-menu-geo-3 page-menu-geo-3">
                <div className="dhvsj" style={{ display: "flex", marginLeft: 75, marginTop: 75, flexDirection: "column", justifyContent: "center" }}>
                  <div className="ssfsdbC">
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "Arasıcaklar")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsgeo" key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                  <div className="djhvms74">
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "Qarnir")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsgeo" key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-geo-4 page-menu-geo-4">
                <div className="dhvsjdfd">
                  <div className="dhvsj" style={{ display: "flex", marginLeft: 75, marginTop: 75, flexDirection: "column", justifyContent: "center" }}>
                    <div className="ssfsdbC">
                      {Object.keys(data)
                        .filter((key) => data[key].Catagory === "Sac Yemekleri")
                        .map((key) => data[key])
                        .sort((a, b) => {
                          const nameA = a.product.toLowerCase();
                          const nameB = b.product.toLowerCase();

                          if (nameA < nameB) return -1;
                          if (nameA > nameB) return 1;

                          // If names are the same, compare prices
                          const priceA = parseFloat(a.price);
                          const priceB = parseFloat(b.price);

                          return priceB - priceA;
                        })
                        .map((item) => (
                          <div className="cardssdsgeo" key={item.product}>
                            <p>{item.product}</p>
                            <p>{item.price}</p>
                          </div>
                        ))}
                    </div>
                    <div className="djhvms74">
                      {Object.keys(data)
                        .filter((key) => data[key].Catagory === "Taş Fırın Ürünleri")
                        .map((key) => data[key])
                        .sort((a, b) => {
                          const nameA = a.product.toLowerCase();
                          const nameB = b.product.toLowerCase();

                          if (nameA < nameB) return -1;
                          if (nameA > nameB) return 1;

                          // If names are the same, compare prices
                          const priceA = parseFloat(a.price);
                          const priceB = parseFloat(b.price);

                          return priceB - priceA;
                        })
                        .map((item) => (
                          <div className="cardssdsgeo" key={item.product}>
                            <p>{item.product}</p>
                            <p>{item.price}</p>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-geo-5 page-menu-geo-5">
                <div className="dhvsjdfd">
                  <div className="djhvms7">
                    <div style={{
                      marginTop: "200px",
                      backgroundColor: "rgb(26, 25, 30)",
                      gap: "10px",
                      display: "flex",
                      flexFlow: "column wrap",
                      justifyContent: "center",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      alignItems: "center",
                      alignContent: "flex-start"
                    }}>
                      {/* Inside the "WHISKEY" category section: */}
                      {Object.keys(data)
                        .filter((key) => data[key].Catagory === "Manqal porsionlar")
                        .map((key) => data[key])
                        .sort((a, b) => {
                          const nameA = a.product.toLowerCase();
                          const nameB = b.product.toLowerCase();

                          if (nameA < nameB) return -1;
                          if (nameA > nameB) return 1;

                          // If names are the same, compare prices
                          const priceA = parseFloat(a.price);
                          const priceB = parseFloat(b.price);

                          return priceB - priceA;
                        })
                        .map((item) => (
                          <div className="cardssdsgeo" key={item.product}>
                            <p>{item.product}</p>
                            <p>{item.price}</p>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-geo-6 page-menu-geo-6">
                <div className="dhvsjdfg" style={{ marginLeft: 75, marginTop: 75 }}>
                  <div style={{ marginTop: 290, display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                    {/* Inside the "WHISKEY" category section: */}
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "Balıq")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsgeo" key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-geo-7 page-menu-geo-7">
                <div className="dhvsjd" style={{ marginTop: 180 }}>
                  <div style={{ marginTop: 290, display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                    {/* Inside the "WHISKEY" category section: */}
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "Fast Food")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsgeo" key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-geo-8 page-menu-geo-8">
                <div style={{ marginTop: 290, display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                  {/* Inside the "WHISKEY" category section: */}
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "Bira Mezeleri")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsgeo" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
              </div>
              <div className="jjhgdf-menu-geo-9 page-menu-geo-9">
                <div style={{ marginTop: 290, display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                  {/* Inside the "WHISKEY" category section: */}
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "Desert")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsgeo" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
              </div>
              <div className="jjhgdf-menu-geo-10 page-menu-geo-10">
                <div style={{ marginTop: 290, display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                  {/* Inside the "WHISKEY" category section: */}
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "Sıcak İçecekler")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsgeo" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
              </div>
              <div className="jjhgdf-menu-geo-11 page-menu-geo-11">
                <div style={{ marginTop: 250, display: "flex", backgroundColor: "rgb(26, 25, 30)", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                  {/* Inside the "WHISKEY" category section: */}
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "Alkolsüz İçecekler")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsgeo" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "Taze Sıkılmış Meyve Suları")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsgeo" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}

                </div>
              </div>
              <div className="jjhgdf-menu-geo-12 page-menu-geo-12">
                <div style={{ marginTop: 290, display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                  {/* Inside the "WHISKEY" category section: */}
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "Raki")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsgeo" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
              </div>
              <div className="jjhgdf-menu-geo-13 page-menu-geo-13">
                <div style={{
                  marginTop: "290px",
                  backgroundColor: "rgb(26, 25, 30)",
                  gap: "10px",
                  display: "flex",
                  flexFlow: "column wrap",
                  justifyContent: "center",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                  alignContent: "flex-start"
                }}>
                  {/* Inside the "WHISKEY" category section: */}
                  <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "TEQUILA")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsgeo" style={{ width: "350px" }} key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                  {/* <h1
                    className="dhjsfbs2"
                    style={{ top: "1322px", left: "285px" }}
                  >
                    WHISKEY
                  </h1> */}
                  <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "viski")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsgeo" style={{ width: "350px" }} key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-geo-14 page-menu-geo-14">
                <div style={{
                  marginTop: "200px",
                  backgroundColor: "rgb(26, 25, 30)",
                  display: "flex",
                  flexFlow: "column wrap",
                  justifyContent: "center",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                  alignContent: "flex-start"
                }}>
                  {/* Inside the "WHISKEY" category section: */}
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "Vodka")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsgeo" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                  {/* <h1 className="dhjsfbs2"
                    style={{ top: "1322px", left: "285px" }}>Bira</h1> */}

                </div>
              </div>
              <div className="jjhgdf-menu-geo-15 page-menu-geo-15">
                <div style={{ marginTop: 10, display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                  {/* Inside the "WHISKEY" category section: */}
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "Bira")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsgeo" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
              </div>
              <div className="jjhgdf-menu-geo-16 page-menu-geo-16">
                <div style={{
                  marginTop: "250px",
                  backgroundColor: "rgb(26, 25, 30)",
                  gap: "25px",
                  display: "flex",
                  flexFlow: "column wrap",
                  justifyContent: "center",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                  alignContent: "flex-start"
                }}>
                  <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                    {/* Inside the "WHISKEY" category section: */}
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "Konyak & Şampanya")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsgeo" style={{ width: "300px" }} key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                  <h1
                      className="dhjsfbs2"
                      style={{ top: "1322px", left: "285px" }}
                    >
                      Likor
                    </h1>
                    {/* Inside the "likor" category section: */}
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "Likor")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsgeo" style={{ width: "300px" }} key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-geo-17 page-menu-geo-17">
                <div style={{ marginTop: 10, display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                  {/* Inside the "WHISKEY" category section: */}
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "Şarap")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsgeo" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
              </div>
              <div className="jjhgdf-menu-geo-18 page-menu-geo-18">
                <div style={{
                  marginTop: "200px",
                  backgroundColor: "rgb(26, 25, 30)",
                  gap: "10px",
                  display: "flex",
                  flexFlow: "column wrap",
                  justifyContent: "center",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                  alignContent: "flex-start"
                }}>
                  <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                    <h1
                      className="dhjsfbs2"
                      style={{ top: "1322px", left: "285px" }}
                    >
                      Alkollü Kokteyller
                    </h1>
                    {/* Inside the "WHISKEY" category section: */}
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "Alkollü Kokteyller")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsgeo" style={{ width: "300px" }} key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                    <h1
                      className="dhjsfbs2"
                      style={{ top: "1322px", left: "285px" }}
                    >
                      Shot set
                    </h1>
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "Shot set")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsgeo" style={{ width: "300px" }} key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                    <p
                      className="dhjsfbs2"
                      style={{ top: "1322px", left: "285px", fontSize: "20px" }}
                    >
                      Alkolsüz Kokteyllər
                    </p>
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "Alkolsüz Kokteyller")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsgeo" style={{ width: "300px" }} key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-geo-19 page-menu-geo-19">
                <div style={{ marginTop: 7, display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                  {/* Inside the "WHISKEY" category section: */}
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "Shisha")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsgeo" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
                <div style={{ marginTop: 7, display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column" }}>
                  {/* Inside the "WHISKEY" category section: */}
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "Fişəng")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsgeo" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default MenuGeu;
